import { Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges, ChangeDetectorRef, OnInit } from '@angular/core';
import { SampleActivity } from '../interfaces/sample-activity';
import { GridHeader, GridDetails } from '../interfaces/grid';
import { IFilterSelectItem } from '../../shared/sample-tracking-select/sample-tracking-select.component';

@Component({
    selector: 'app-sample-activity',
    template: require('./sample-activity.component.html'),
    styles: [require('./sample-activity.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SampleActivityComponent implements OnChanges {

    @Input()
    public isLoadingCompleted: boolean;
    
    @Input()
    public activityDetails: SampleActivity[];

    @Input()
    public activityHeader = this.gridHeader();

    @Input()
    public loadingText = 'Loading Sample Activity...';

    public gridDetails: GridDetails;
    public displayType = 'grid';

    public timelineOptions: IFilterSelectItem[];
    public defaultTimelineOption: IFilterSelectItem[] = [{
        id: 1,
        value: 'Newest - Oldest'
    }];
    constructor(public changeDetectorRef: ChangeDetectorRef) {
        this.timelineOptions = this.getTimelineOptions();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.activityDetails) {
            this.activityDetails?.forEach(t => {
                t.hideDescription = t.activityStatus === 'Cancelled' ? true : false;
            });
            this.onTimelineChange(this.defaultTimelineOption);
        }
    }

    public onTimelineChange($event: IFilterSelectItem[]) {
        if (!this.activityDetails || !this.activityDetails.length) { return; }
        this.activityDetails = $event[0].id === 1 ? this.activityDetails.sort((a, b) => new Date(b.formattedDateTime).getTime() - new Date(a.formattedDateTime).getTime()) :
            this.activityDetails.sort((a, b) => new Date(a.formattedDateTime).getTime() - new Date(b.formattedDateTime).getTime());
        this.gridDetails = { header: this.activityHeader, data: this.activityDetails };
        this.changeDetectorRef.markForCheck();
    }

    public onDisplayChange(type: string) {
        this.displayType = type;
        this.changeDetectorRef.markForCheck();
    }

    private getTimelineOptions(): IFilterSelectItem[] {
        return [
            {
                id: 1,
                value: 'Newest - Oldest',
            },
            {
                id: 2,
                value: 'Oldest - Newest'
            }
        ];
    }

    private gridHeader(): GridHeader[] {
        return [
            {
                key: 'activityDescription',
                displayText: 'Status',
            },
            {
                key: 'formattedDateTime',
                displayText: 'Date/Time'
            },
            {
                key: 'fromLocation',
                displayText: 'From Location'
            },
            {
                key: 'toLocation',
                displayText: 'To Location',
            },
            {
                key: 'airwayBillNumber',
                displayText: 'AirwayBill Number'
            },
            {
                key: 'cancellationDescription',
                displayText: 'Cancellation Description'
            },
        ];
    }
}